import { render, staticRenderFns } from "./TextOrNumberFilter.vue?vue&type=template&id=1a1d5488&"
import script from "./TextOrNumberFilter.vue?vue&type=script&lang=js&"
export * from "./TextOrNumberFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports